(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var siteHeader = document.querySelector("[data-nav]");
    var toggle = document.querySelector("[data-nav-toggle]");
    var closeBtn = document.querySelector("[data-nav-close]");
    var mobileNav = document.querySelector("[data-mobile-nav]");
    if (!toggle || !mobileNav) {
      return;
    }

    var links = mobileNav.querySelectorAll(".mobile-nav__item");
    var isOpen = false;

    function animateItems() {
      if (!window.gsap) {
        return;
      }
      window.gsap.fromTo(
        links,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5, stagger: 0.08, ease: "power2.out" }
      );
    }

    function openNav() {
      if (isOpen) {
        return;
      }
      isOpen = true;
      siteHeader.classList.add("is-open");
      mobileNav.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      animateItems();
    }

    function closeNav() {
      if (!isOpen) {
        return;
      }
      isOpen = false;
      siteHeader.classList.remove("is-open");
      mobileNav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }

    toggle.addEventListener("click", openNav);
    if (closeBtn) {
      closeBtn.addEventListener("click", closeNav);
    }
    mobileNav.addEventListener("click", function (event) {
      if (event.target.classList.contains("mobile-nav__link")) {
        closeNav();
      }
    });
    
    function getFirstSegment(pathname) {
      if (!pathname) {
        return "";
      }
      var cleanPath = pathname.split("?")[0].split("#")[0];
      var segments = cleanPath.split("/").filter(Boolean);
      return segments[0] ? segments[0].toLowerCase() : "";
    }

    var mainSegment = getFirstSegment(window.location.pathname);
    if (mainSegment) {
      var navLinks = document.querySelectorAll(
        "header .site-nav .site-nav__list a"
      );
      navLinks.forEach(function (link) {
        var href = link.getAttribute("href");
        if (!href) {
          return;
        }
        var linkPath = href;
        if (href.indexOf("http://") === 0 || href.indexOf("https://") === 0) {
          try {
            linkPath = new URL(href).pathname;
          } catch (error) {
            return;
          }
        }
        var linkSegment = getFirstSegment(linkPath);
        if (!linkSegment) {
          return;
        }
        if (linkSegment === mainSegment) {
          link.classList.add("is-active");
        }
      });
    }

  });
})();
